import BaseURL from "./baseURL";

const quizAPI = {
	QUES_URL: `${BaseURL.LOCAL_BASE_URL}/quiz/questions`,
	PROGRESS_URL: `${BaseURL.LOCAL_BASE_URL}/quiz/progress`,
	SUBMIT_ANS_URL: `${BaseURL.LOCAL_BASE_URL}/quiz/submit-answer`,
};

export default quizAPI;
